import React from "react";
import { Chip, alpha } from "@mui/material";
import { LinkOffRounded } from "@mui/icons-material";
import ActionButton from "../../../components/atoms/ActionButton";
import { EntityHeader } from "../../../components/molecules";
import { COLORS } from "../../../styles/uiConstants";
import useTerms from "../../../hooks/useTerms";

const calcAge = (birthDay) => {
  if (!birthDay) return null;
  const d = new Date(birthDay);
  if (Number.isNaN(d.getTime())) return null;
  const now = new Date();
  let age = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age -= 1;
  return age >= 0 ? age : null;
};

const buildSubline = (patient) => {
  const parts = [];
  const age = calcAge(patient?.birthDay);
  if (age != null) parts.push(`${age} yaşında`);
  if (patient?.gender) parts.push(patient.gender);
  if (patient?.bloodType) parts.push(patient.bloodType);
  return parts.join(" · ");
};

export default function PatientHeader({
  patient,
  onBack,
  onDelete,
  canDelete,
  tab,
  onTabChange,
  tabs,
}) {
  const terms = useTerms();
  const fullName = patient
    ? `${patient.name || ""} ${patient.surname || ""}`.trim() || `${terms.patient} Detayı`
    : `${terms.patient} Detayı`;
  const initials = patient
    ? `${(patient.name || "")[0] || ""}${(patient.surname || "")[0] || ""}`.toUpperCase() || terms.patient[0]
    : terms.patient[0];
  const subline = buildSubline(patient);
  // "Mesaj gönder" kısayolu 2026-10-07'de kaldırıldı — mesajlaşma hasta detayının
  // İletişim sekmesinde.
  const isActive = patient?.accountStatus ? patient.accountStatus === "Aktif" : true;

  const statusChip = (
    <Chip
      key="status"
      label={isActive ? "Aktif" : "Pasif"}
      size="small"
      sx={{
        height: 24,
        fontSize: "0.7rem",
        fontWeight: 700,
        bgcolor: alpha(isActive ? COLORS.successDark : COLORS.slate400, 0.08),
        color: isActive ? COLORS.successDark : COLORS.slate600,
      }}
    />
  );

  return (
    <EntityHeader
      onBack={onBack}
      avatar={{ initials, alt: fullName }}
      title={fullName}
      subtitle={subline || undefined}
      chips={[statusChip]}
      actions={
        canDelete && onDelete ? (
          <>
            {canDelete && onDelete ? (
              <ActionButton
                variant="delete"
                compact
                label="Klinikten Çıkar"
                icon={<LinkOffRounded sx={{ fontSize: 15 }} />}
                onClick={onDelete}
              />
            ) : null}
          </>
        ) : null
      }
      tabs={(tabs || []).map((t) => ({ key: t.value, label: t.label }))}
      activeTab={tab}
      onTabChange={onTabChange}
    />
  );
}
